import React, { useState, useEffect, useRef } from "react";

import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

import axios from 'axios';
import Swal from "sweetalert2";
import dayjs from 'dayjs';
import 'dayjs/locale/id';

import 'dayjs/locale/id';
import 'dayjs/locale/en';

import { useCookies } from 'react-cookie';
import BeritaCard from "../BeritaCard";

const Section7 = () => {

	// eslint-disable-next-line
	const [cookies] = useCookies(['i18next']);
	// eslint-disable-next-line
	const formatDate = (date, locale = 'en') => {
		dayjs.locale(locale); // Set the locale dynamically
		return dayjs(date).format('DD MMMM YYYY'); // Format the date
	};

	const [posts, setPosts] = useState([]);
	const [activePage, setActivePage] = useState(0);
	const [totalPages, setTotalPages] = useState(0);
	const swiperRef = useRef(null);

	useEffect(() => {
		const fetchPosts = async () => {
			try {
				const url = process.env.REACT_APP_API_URL;
				const endpoint = process.env.REACT_APP_API_POST;
				const response = await axios.get(`${url}${endpoint}`);
				setPosts(response.data);
			} catch (err) {
				Swal.fire({
					icon: "error",
					title: "Oops...",
					text: err,
				});
			}
		};

		fetchPosts();
	}, []);

	useEffect(() => {
		if (posts.length > 0) {
			if (document.querySelector('.swiper-berita')) {
				const swiperInstance = new Swiper('.swiper-berita', {
					loop: false,
					slidesPerView: 1,
					slidesPerGroup: 1,
					spaceBetween: 20,
					breakpoints: {
						640: {
							slidesPerView: 2,
							slidesPerGroup: 2,
							spaceBetween: 20,
						},
						768: {
							slidesPerView: 3,
							slidesPerGroup: 3,
							spaceBetween: 20,
						},
						1024: {
							slidesPerView: 4,
							slidesPerGroup: 4,
							spaceBetween: 20,
						},
					},
					on: {
						init: function () {
							const snaps = this.snapGrid.length;
							setTotalPages(snaps);
							setActivePage(0);
						},
						slideChange: function () {
							setActivePage(this.snapIndex);
						},
						resize: function () {
							const snaps = this.snapGrid.length;
							setTotalPages(snaps);
						}
					}
				});

				swiperRef.current = swiperInstance;

				return () => {
					if (swiperInstance && swiperInstance.destroy) {
						swiperInstance.destroy(true, true);
					}
				};
			}
		}
	}, [posts]);

	const convertToSlug = (title) => {
		return title
			.toLowerCase()
			.trim()
			.replace(/[^\w\s-]/g, '')
			.replace(/\s+/g, '-')
			.replace(/-+/g, '-');
	};

	const handlePrev = () => {
		if (swiperRef.current) swiperRef.current.slidePrev();
	};

	const handleNext = () => {
		if (swiperRef.current) swiperRef.current.slideNext();
	};

	const goToPage = (index) => {
		if (swiperRef.current) swiperRef.current.slideTo(swiperRef.current.params.slidesPerGroup * index);
	};

	const paginationStyle = {
		container: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			gap: '10px',
			marginTop: '10px',
		},
		navBtn: {
			width: '38px',
			height: '38px',
			borderRadius: '50%',
			border: '2px solid #e0e0e0',
			background: '#ffffff',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			cursor: 'pointer',
			transition: 'all 0.3s ease',
			color: '#6c757d',
			fontSize: '0.9rem',
			flexShrink: 0,
		},
		navBtnDisabled: {
			opacity: 0.4,
			cursor: 'default',
		},
		pageBtn: {
			width: '36px',
			height: '36px',
			borderRadius: '8px',
			border: 'none',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			cursor: 'pointer',
			transition: 'all 0.3s ease',
			fontSize: '0.9rem',
			fontWeight: '600',
			flexShrink: 0,
		},
		pageBtnActive: {
			background: '#00994B',
			color: '#ffffff',
			boxShadow: '0 3px 10px rgba(0, 153, 75, 0.35)',
		},
		pageBtnInactive: {
			background: '#f1f3f5',
			color: '#6c757d',
		},
	};


	return (
		<section className="portfolio-section mb-5">
			<div className="portfolio-content" data-aos="fade-up" data-aos-anchor-placement="bottom-bottom">
				<div className="container">
					<div className="row m-0">
						{posts.length > 0 ? (
							<>
								<style>
									{`
									.swiper-berita .swiper-button-next,
									.swiper-berita .swiper-button-prev {
										display: none !important;
									}
									.swiper-berita .swiper-pagination {
										display: none !important;
									}
									.s7-nav-btn:hover {
										border-color: #00994B !important;
										color: #00994B !important;
										background: #f0fdf4 !important;
									}
									.s7-page-btn:hover {
										background: #e0e0e0 !important;
									}
									.s7-page-btn-active:hover {
										background: #00994B !important;
									}
									`}
								</style>
								<div className="swiper swiper-berita">
									<div className="swiper-wrapper">
										{posts.slice(3, 25).map((item) => (
											<div className="swiper-slide" key={item.id} style={{ height: "auto" }}>
												<BeritaCard
													item={item}
													href={`/berita-terkait/${btoa(item.id)}/${convertToSlug(item.title)}`}
												/>
											</div>
										))}
									</div>
								</div>

								{/* Custom Pagination Controls */}
								{totalPages > 1 && (
									<div style={paginationStyle.container}>
										<div
											className="s7-nav-btn"
											style={{
												...paginationStyle.navBtn,
												...(activePage === 0 ? paginationStyle.navBtnDisabled : {}),
											}}
											onClick={handlePrev}
										>
											<i className="fa-solid fa-chevron-left"></i>
										</div>

										{(() => {
											let pages = [];
											if (totalPages <= 5) {
												pages = Array.from({ length: totalPages }, (_, i) => i);
											} else if (activePage <= 1) {
												pages = [0, 1, 2, '...', totalPages - 1];
											} else if (activePage >= totalPages - 2) {
												pages = [0, '...', totalPages - 3, totalPages - 2, totalPages - 1];
											} else {
												pages = [0, '...', activePage, '...', totalPages - 1];
											}
											return pages.map((page, idx) =>
												page === '...' ? (
													<span key={`ellipsis-${idx}`} style={{ color: '#6c757d', fontSize: '14px', padding: '0 4px' }}>...</span>
												) : (
													<div
														key={page}
														className={`s7-page-btn ${activePage === page ? 's7-page-btn-active' : ''}`}
														style={{
															...paginationStyle.pageBtn,
															...(activePage === page ? paginationStyle.pageBtnActive : paginationStyle.pageBtnInactive),
														}}
														onClick={() => goToPage(page)}
													>
														{page + 1}
													</div>
												)
											);
										})()}

										<div
											className="s7-nav-btn"
											style={{
												...paginationStyle.navBtn,
												...(activePage === totalPages - 1 ? paginationStyle.navBtnDisabled : {}),
											}}
											onClick={handleNext}
										>
											<i className="fa-solid fa-chevron-right"></i>
										</div>
									</div>
								)}
							</>
						) : (
							<p className="text-center">No posts available.</p>
						)}
					</div>
				</div>
			</div>
		</section>
	)
}
export default Section7
